const COOKIE = {
    FLEX_HOST: 'flex-host',
    FLEX_SU: 'flex-su'
};

const EVENT = {
    GLOBAL: {
        ADD_PAGE_ALERTS: 'global:add-page-alerts',
        ADD_PAGE_MODAL_CONTENT: 'global:add-page-modal-content',
        API_AUTH_FAILED: 'global:api-auth-failed',
        API_EXCEPTION: 'global:api-exception',
        LOAD_CONFIG_CODES: 'global:load-config-codes',
        NAVIGATE: 'global:navigate',
        PING: 'global:ping',
        PING_SUCCESS: 'global:ping-success',
        PING_FAILED: 'global:ping-failed',
        REMOVE_PAGE_ALERTS: 'global:remove-page-alerts',
        REMOVE_PAGE_MODAL_CONTENT: 'global:remove-page-modal-content',
        SESSION_LOGGED_IN: 'global:session-loggedin',
        SESSION_LOGGED_OUT: 'global:session-loggedout'
    }
};
const RX = {
    GLOBAL: EVENT.GLOBAL,
    TRACK: {
        SESSION_LOGGED_IN: `track:${EVENT.GLOBAL.SESSION_LOGGED_IN}`,
        TIMING: `track:global:timing`
    },
    TERMS_AND_CONDITIONS: {
        CLEAR_BRANCH: 'RX:TERMS_AND_CONDITIONS:CLEAR_BRANCH',
        GET_DEALERS_INFO: 'RX:TERMS_AND_CONDITIONS:GET_DEALERS_INFO',
        ACCEPT_DEALERS: 'RX:TERMS_AND_CONDITIONS:ACCEPT_DEALERS'
    }
};

const TIMER_NAME = {
    CALLBACK: 'CallbackTimer',
    OVERALL: 'OverallTimer',
    REQUEST: 'RequestTimer'
};
const TIMER_TYPE = {
    BEGIN_REQUEST: 'BeginRequest',
    REQUEST_ERROR: 'RequestError',
    LONG_RUNNING_REQUEST: 'LongRunningRequest',
    REQUEST_COMPLETE: 'RequestComplete'
};

const PHONE_VALIDATION = {
    REG_EX: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/,
    MESSAGE: 'A 10 Digit Number is Required. Format: 555-555-5555'
};

const USA_POSTAL_CODE_VALIDATION = {
    REG_EX: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
    MESSAGE: 'Enter a valid postal code'
};

const CANADIAN_POSTAL_CODE_VALIDATION = {
    REG_EX: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
    MESSAGE: 'Enter a valid postal code'
};

const NO_WHITE_SPACE_CODE_VALIDATION = {
    REG_EX: /^\S*$/
}

const CHECK_SPECIAL_WORDS_CODE_VALIDATION = {
    REG_EX: /^[-.@_A-Za-z0-9 ]+$/
}

const CHECK_CHARACTER_VALIDATION = {
    REG_EX: /^[A-Za-z0-9_\@-]+$/
}

const CHECK_NOT_START_SPECIAL_CHARACTER_VALIDATION = {
    REG_EX: /^[A-Za-z0-9]/
}

const EMAIL_VALIDATION = {
    REG_EX: /^[\w-\.]+@[a-zA-Z0-9](?:[\w-]+\w{0,61})?(?:\.\w(?:\w{0,61}\w)?)*$/
}

const CONTACT_KINDS = {
    EMAIL: 'Email',
    PHONE: 'Phone',
    FAX: 'Fax',
    WEBSITE: 'Website',
    TWITTER: 'Twitter'
};

const CONFIG_CODES = {
    ACTIVATION_STATE: 'activationStateCodes',
    ORG_KIND_CODES: 'orgKindCodes',
    UNITED_STATES: 'unitedStates',
    CANADIAN_PROVINCES: 'canadianProvinces'
};

const APP_KINDS = {
    ADMIN: 'Admin',
    API: 'Api',
    MARKETPLACE: 'Marketplace',
    MOBILE: 'Mobile'
};

const VALIDATION_ERROR_MESSAGES = {
    MIN_LENGTH: (fieldName, minLength) => `${fieldName} must be at least ${minLength} characters long`,
    MAX_LENGTH: (fieldName, maxLength) => `${fieldName} must be no more than ${maxLength} characters long`,
    UNIQUE: fieldName => `${fieldName} must be unique`,
    MATCH_REGEXP: (fieldName, symbols) => `${fieldName} can contain only: ${symbols.join(', ')}`,
    REQUIRED: fieldName => `${fieldName} is required`
}

const SORT_DIRECTIONS = {
    DESC: 'DESC',
    ASC: 'ASC'
}

const DATA_FORMAT_TYPES = {
    LOCAL_DATE: 'localDate',
    LOCAL_DATE_TIME: 'localDateTime',
    DATE: 'date',
    DATE_TIME: 'dateTime',
    SELECT: 'select',
    LIST: 'list',
    LINK: 'link',
    CONTENT: 'content',
    TEXT: 'text'
};

const MESSAGE_COLORS = {
    ERROR: 'danger',
    INFO: 'info'
};


const MODAL_SIZES = {
    SMALL: 'sm',
    LARGE: 'lg'
};

const FEATURE_TOGGLES = {
    USE_SINGLE_LOGOUT: 'UseSingleLogout',
    WIDE_CONTAINER: 'WideContainer',
    CAN_OVERRIDE_HOME_MODULE: 'CanOverrideHomeModule',
    INTERIM_HEADER: 'InterimHeader',
    USE_FIRST_PARTY_COOKIES: 'UseFirstPartyCookies'
};

const USER_NAME_LENGTH = {
    MIN: 4,
    MAX: 30
};

const NAME_LENGTH = {
    MIN: 2
};

const ORG_USER_ACTIVATION_STATUS = {
    ACTIVE: 'Active',
    PENDING: 'Pending',
    CANCELED: 'Canceled',
    EXPIRED: 'Expired',
    ARCHIVED: 'Archived',
    INACTIVE: 'InActive'
};

const CLAIMS = {
    PREDICTIVE_DEALER_SEARCH: 'fea.Home.EnablePredicitiveDealerSearch',
    USE_MDO: 'per.Inventory.UseMDO',
    DISABLE_WIDE_CONTAINER: 'per.Home.DisableWideContainer',
    CAN_EDIT_PROFILE_CONTACT_INFO: 'per.Home.CanEditProfileContactInfo',
    CAN_EDIT_SECURITY_SETTINGS: 'per.Home.CanEditSecuritySettings'
};

const PING_DOMAIN = {
    FLEX: 'flex',
    RMS_PCNA: 'rms_pcna',
    MANHEIM_CUSTOMER: 'manheim-customer'
}

const OAUTH_IDENTIFIER_KIND = {
    FLEX: 'OAUTH-RMS',
    PCNA: 'OAUTH-RMS-PCNA',
    MANHEIM: 'OAUTH-MANHEIM'
};

const USERNAME_CAPTURE_GROUP = 'username';

const OAUTH_IDENTIFIER_FORMAT = {
    [OAUTH_IDENTIFIER_KIND.FLEX]: new RegExp(`flex:(?<${USERNAME_CAPTURE_GROUP}>.+)`),
    [OAUTH_IDENTIFIER_KIND.PCNA]: new RegExp(`rms_pcna:(?<${USERNAME_CAPTURE_GROUP}>.+)`),
    [OAUTH_IDENTIFIER_KIND.MANHEIM]: new RegExp(`manheim_customer:(?<${USERNAME_CAPTURE_GROUP}>.+)`)
};

const DEFAULT_MAPPER_VALUE = {
    ZERO: 0,
    EMPTY_STRING: '',
    EMPTY_OBJ: {},
    EMPTY_LIST: [],
    BOOL_FALSE: false,
    BOOL_TRUE: true,
    UNDEFINED_STRING: 'undefined'
};

const COLIST_GROUP_CODE = 'COLIST';

const ADOBE_CONSTANTS = {
    FIREBALL_SIGNATURE: 'rms-fireball'
};

const DEFAULT_PHONE_COUNTRY = 'US';

module.exports = {
    COOKIE,
    EVENT,
    RX,
    TIMER_NAME,
    TIMER_TYPE,
    PHONE_VALIDATION,
    USA_POSTAL_CODE_VALIDATION,
    CANADIAN_POSTAL_CODE_VALIDATION,
    CONTACT_KINDS,
    CONFIG_CODES,
    APP_KINDS,
    VALIDATION_ERROR_MESSAGES,
    SORT_DIRECTIONS,
    DATA_FORMAT_TYPES,
    MESSAGE_COLORS,
    MODAL_SIZES,
    FEATURE_TOGGLES,
    USER_NAME_LENGTH,
    NAME_LENGTH,
    ORG_USER_ACTIVATION_STATUS,
    CLAIMS,
    PING_DOMAIN,
    DEFAULT_MAPPER_VALUE,
    OAUTH_IDENTIFIER_KIND,
    USERNAME_CAPTURE_GROUP,
    OAUTH_IDENTIFIER_FORMAT,
    COLIST_GROUP_CODE,
    NO_WHITE_SPACE_CODE_VALIDATION,
    CHECK_SPECIAL_WORDS_CODE_VALIDATION,
    ADOBE_CONSTANTS,
    CHECK_CHARACTER_VALIDATION,
    CHECK_NOT_START_SPECIAL_CHARACTER_VALIDATION,
    EMAIL_VALIDATION,
    DEFAULT_PHONE_COUNTRY
};
